import React, { useEffect } from 'react';
import TabPanel from '../../../components/Tabpanel';
import { Tabs, Tab, Button } from '@material-ui/core';
import { Link, useParams, useLocation } from 'react-router-dom';
import {
  FaRegNewspaper, FaInfoCircle,
  // FaTwitter, FaFacebook
} from 'react-icons/fa';
import { FiRefreshCw } from 'react-icons/fi';
import InfoCard from '../../../components/infoCard';
import InfoCard2 from '../../../components/infoCard/InfoCard';

import { useDispatch, useSelector } from 'react-redux';
import PRModel from '../../../models/pressrelease-downloads.model';
import { fetchPR } from '../../../services/press-download.service';
import translates from '../../../translation.json';
import { lang } from '../../../config/app.config';
import News from '../../../models/news.model';
import { fetchNotices } from '../../../services/notice.service';
import { TranslationState } from '../../../store/ActionReducers/translation.actionreducer';
// import Facebook from '../SocialFeeds/facebook';
// import Twitter from '../SocialFeeds/twitter';

interface state {
  pressrelease: {
    pressReleases: Array<PRModel>,
    loadingPressRelease: boolean,
  },
  notice: {
    notices: Array<News>,
    loading: boolean
  },
  translation: TranslationState
}


interface params {
  dist_slug: string,
}

type LocationState = {
  pathname: string
}

interface Props {
  news: Array<News>
  loadingNews: boolean,
  // isProvince: boolean
}
const InfoTab: React.FC<Props> = (props) => {

  const { loadingNews, news } = props;

  const { dist_slug } = useParams<params>();
  const { pathname } = useLocation<LocationState>();


  const translations = translates.translation;
  // redux store
  const dispatch = useDispatch();

  const state = useSelector((state: state) => {
    return state;
  });
  const { notice, pressrelease, translation } = state;
  const { loading, notices } = notice;
  const { loadingPressRelease, pressReleases } = pressrelease;
  //load press release
  const loadPR = (page: number = 1) => {
    dispatch(fetchPR(page, dist_slug));
  }
  const loadNotice = (page: number = 1) => {
    dispatch(fetchNotices(page, dist_slug));
  }
  const isProvince = pathname?.includes('province');

  useEffect(() => {
    loadPR();
    loadNotice();
  }, [dispatch]) //eslint-disable-line
  // end redux store


  const [value, setValue] = React.useState('press_release');

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div className="br-6px m-2">
      <Tabs value={value} onChange={handleChange} className='custom-tabs' aria-label="wrapped label tabs example">

        <Tab value="press_release" label={
          <div className='custom-tab'>
            <FaRegNewspaper /> <span>{translation.translation ? translation.translation.press_release[lang === 'np' ? 'value_np' : 'value_en'] : ''}</span>
          </div>
        } wrapped />

        <Tab value="information" label={
          <div className='custom-tab'>
            <FaInfoCircle /> <span>{translation.translation ? translation.translation.information[lang === 'np' ? 'value_np' : 'value_en'] : ''}</span>
          </div>
        } />

        <Tab value="latest_updates" label={
          <div className='custom-tab'>
            <FiRefreshCw /> <span>{translation.translation ? translation.translation.recent_updates[lang === 'np' ? 'value_np' : 'value_en'] : ''}</span>
          </div>
        } />
        {/* 
      <Tab value="facebook" label={
        <div className='custom-tab'>
          <FaFacebook/> <span>{translations[lang].facebook_feeds}</span> 
        </div>
      }/>

      <Tab value="twitter" label={
        <div className='custom-tab'>
          <FaTwitter/> <span>{translations[lang].twitter_feeds}</span> 
        </div>
      }/> */}

      </Tabs>

      <TabPanel value={value} index="press_release" bgWhite={true}>
        <div>
          {!loadingPressRelease ?
            pressReleases && pressReleases.length ?
              pressReleases.slice(0, 4).map((data, i) => (
                <InfoCard key={data.id} data={data} />
              )) : <h4 className="text-14-primary text-center">Sorry no press releases found</h4>
            : ''
          }
          <div className="section-break-2 pb-0">
            <Link
              to={`/${lang}/${dist_slug ? `${isProvince ? 'province' : 'district'}/press-release/${dist_slug}` : 'press-release'}`}
            >
              <Button className="btn-primary">{translations[lang].view_all}</Button>
            </Link>
          </div>
        </div>
      </TabPanel>

      <TabPanel value={value} index="information" bgWhite={true}>
        <div>
          {!loading ?
            notices && notices.length ?
              notices.slice(0, 4).map((data: any, i) => (
                <InfoCard key={data?.id} data={data} />
              )) : <h4 className="text-14-primary text-center">Sorry no information found</h4>
            : ''
          }
          <div className="section-break-2 pb-0" style={{ marginTop: '8px' }}>
            <Link
              to={`/${lang}/${dist_slug ? `${isProvince ? 'province' : 'district'}/notice/${dist_slug}` : 'notice'}`}
            >
              <Button className="btn-primary">{translations[lang].view_all}</Button>
            </Link>
          </div>
        </div>
      </TabPanel>

      <TabPanel value={value} index="latest_updates" bgWhite={true}>
        <div>
          {!loadingNews ?
            news && news.length ?
              news.slice(0, 4).map((data, i) => (
                <InfoCard2 key={data.id} data={data} prefix="news" />
              )) : <h4 className="text-14-primary text-center">Sorry no updates found</h4>
            : ''
          }
          <div className="section-break-2 pb-0">
            <Link
              to={`/${lang}/${dist_slug ? `${isProvince ? 'province' : 'district'}/news/${dist_slug}` : 'news'}`}
            >
              <Button className="btn-primary">{translations[lang].view_all}</Button>
            </Link>
          </div>
        </div>
      </TabPanel>


      {/* <TabPanel value={value} index="facebook">
        <div>
          <Facebook/>
        </div> 
      </TabPanel>

      <TabPanel value={value} index="twitter">
        <div>
          <Twitter/>
        </div> 
      </TabPanel> */}

    </div>
  );
}

export default InfoTab;
